// https://itnext.io/angular-create-your-own-modal-boxes-20bb663084a1
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {DomService} from '../dom/dom.service';
import {BehaviorSubject} from 'rxjs';
import {WINDOW} from '../../Services/window/window.service';

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    private screenYPosition;

    constructor(private domService: DomService,
                @Inject(PLATFORM_ID) private platform: Object,
                @Inject(DOCUMENT) private document: Document,
                @Inject(WINDOW) private window) {
    }

    private modalElementId = 'modalContainer';
    private overlayElementId = 'overlay';

    private modalClosing = new BehaviorSubject<any>(true);
    modalClosingObs = this.modalClosing.asObservable();

    init(component: any, inputs: object | any, outputs: object) {
        if (isPlatformBrowser(this.platform)) {
            const modalDomObject = <HTMLElement>document.getElementById(this.modalElementId);
            if (modalDomObject) {
                try {
                    this.domService.removeComponent();
                } catch (e) {
                    console.warn(e);
                }
            }
        }

        const componentConfig = {
            inputs: inputs,
            outputs: outputs
        };
        this.domService.appendComponentTo(this.modalElementId, component, componentConfig);
        if (isPlatformBrowser(this.platform)) {
            this.screenYPosition = this.determineYPosition();
            document.getElementsByTagName('body')[0].classList.add('overflowHidden');
            document.getElementsByTagName('app-root')[0].classList.add('blur');
            if (inputs.filters) {
                document.getElementsByTagName('app-root')[0].classList.remove('blur');
                document.getElementsByTagName('app-root')[0].classList.add('filtersBlur');
            }
            if (inputs.type === 'explore') {
                document.getElementsByTagName('body')[0].classList.add('manualTrip');
            }
            // document.getElementsByTagName('body')[0].style.top = '-' + this.screenYPosition + 'px';
            document.body.style.paddingRight = this.getScrollBarWidth() + 'px';
            document.getElementById('authNav').style.marginRight = this.getScrollBarWidth() + 'px';
            if (inputs.photosPopup) {
                document.getElementById(this.modalElementId).classList.add('photosPopup');
            }
            if (inputs.videoPopup) {
                document.getElementById(this.modalElementId).classList.add('videosPopup');
            }
            if (inputs.popupWithHeader) {
                document.getElementById(this.modalElementId).classList.add('popupWithHeader');
            }
            document.getElementById(this.modalElementId).style.display = 'block';
            document.getElementById(this.overlayElementId).style.display = 'block';
            document.getElementById(this.modalElementId).style.opacity = '1';
            document.getElementById(this.overlayElementId).style.opacity = '1';
            if (inputs.activityIndicator) {
                document.getElementsByTagName('body')[0].classList.add('activityIndicator');
            }
            if (inputs.exploreTrip) {
                document.getElementById(this.overlayElementId).classList.add('darker');
            }
        }
    }

    destroy(bookingFlow?, noScroll?) {
        if (isPlatformBrowser(this.platform)) {
            if (bookingFlow) {
                const modalDomObject = <HTMLElement>document.getElementById(this.modalElementId);
                if (modalDomObject) {
                    try {
                        this.domService.removeComponent();
                    } catch (e) {
                        console.warn(e);
                    }
                }
            } else {
                document.getElementsByTagName('app-root')[0].classList.remove('blur');
                document.body.style.paddingRight = '';
                document.getElementById('authNav').style.marginRight = '';
                document.getElementsByTagName('body')[0].classList.remove('overflowHidden');
                document.getElementById(this.modalElementId).style.zIndex = '';
                document.getElementById(this.modalElementId).classList.remove('photosPopup');
                document.getElementById(this.modalElementId).classList.remove('videosPopup');
                document.getElementById(this.modalElementId).classList.remove('popupWithHeader');
                document.getElementsByTagName('body')[0].classList.remove('closingModal');
                document.getElementsByTagName('body')[0].classList.remove('activityIndicator');
                document.getElementById(this.overlayElementId).classList.remove('darker');
                jQuery('#' + this.modalElementId).fadeOut('fast', function () {
                    document.getElementById(this.modalElementId).style.opacity = '0';
                    const modalDomObject = <HTMLElement>document.getElementById(this.modalElementId);
                    if (modalDomObject) {
                        try {
                            this.domService.removeComponent();
                        } catch (e) {
                            console.warn(e);
                        }
                    }
                }.bind(this));
                jQuery('#' + this.overlayElementId).fadeOut('fast', function () {
                    document.getElementById(this.overlayElementId).style.opacity = '0';
                    document.getElementsByTagName('app-root')[0].classList.remove('filtersBlur');
                    document.getElementsByTagName('body')[0].classList.remove('manualTrip');
                }.bind(this));
            }
        }
    }

    closeModal(res) {
        this.modalClosing.next(res);
    }

    overlayClicked(e) {
        if (document.getElementsByTagName('body')[0].classList.contains('activityIndicator')) {
            return;
        }
        if (document.getElementsByTagName('app-root')[0].classList.contains('filtersBlur')) {
            this.closeModal(true);
            this.destroy();
        } else {
            this.destroy();
        }
    }

    getScreenYPos() {
        return this.window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
    }

    determineYPosition() {
        const currentScreenPosition = this.getScreenYPos();
        const bodyTopPosition = Math.abs(parseInt(document.getElementsByTagName('body')[0].style.top, 10));
        if (bodyTopPosition) {
            return bodyTopPosition;
        } else {
            return currentScreenPosition;
        }
    }

    getScrollBarWidth() {
        const outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'),
            widthWithScroll = $('<div>').css({width: '100%'}).appendTo(outer).outerWidth();
        outer.remove();
        return 100 - widthWithScroll;
    }

    removeFiltersModalClasses() {
        document.getElementsByTagName('app-root')[0].classList.remove('filtersBlur');
    }
}
